export const maxStringLength = (str, maxChar) => {
  if (str.length > maxChar) {
    const truncatedStr = str.slice(0, maxChar)
    return `${truncatedStr}...`
  }

  return str
}
